import {GET_SELECTEDDAY} from '../Actions/types'

const initialState= { 
    selectedDay: "",

}

export default function (state = initialState, action) {

        switch(action.type) {
            case GET_SELECTEDDAY: 
                return{
                    ...state,
                    selectedDay: action.payload
                };
                default: 
            return state;

        }
    }



// WEBPACK FOOTER //
// ./src/Reducers/GetSelectedDayReducer.js